export class Templates {
  public static listItem(lead: string, content: string) {
    return '<li><span class="data-lead">' + lead + '</span><span class="data-content">' + content + '</span></li>';
  }
}



// WEBPACK FOOTER //
// ./src/app/common/preview.service/renderers/templates.ts